module.exports = __webpack_public_path__ + "static/media/Ramsay Bolton 3.a513329a.jpg";